module.exports = __webpack_public_path__ + "fonts/7d4b86223637a9b88a07b16bc7d380fb.svg";